var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"style":{"fill":"none","strokeWidth":"25","strokeMiterlimit":"4","strokeLinecap":"round"},"id":"top","d":"M 24.269265,32.320442 H 233.11363 c 176.98675,0 88.49338,283.178798 -17.69868,176.986748 L 20.72953,14.621766","key":0}),React.createElement("path",{"style":{"fill":"none","strokeWidth":"25","strokeMiterlimit":"4","strokeLinecap":"round"},"id":"middle","d":"m 24.269265,120.81382 h 212.3841","key":1}),React.createElement("path",{"style":{"fill":"none","strokeWidth":"25","strokeMiterlimit":"4","strokeLinecap":"round"},"id":"bottom","d":"M 24.269265,216.38667 H 233.11363 c 176.98675,0 88.49338,-283.17881 -17.69868,-176.986758 C 144.62026,110.19461 20.72953,234.08534 20.72953,234.08534","key":2})]);
}

HamburgerInline.defaultProps = {"version":"1.1","viewBox":"0 0 354.86795 248.70711"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
